import user from './user.json';
import statisticalData from './statistical-data.json';
import friends from './friends.json';
import transictions from './transactions.json';

const data = { user, statisticalData, friends, transictions };
export default data;
